import React from 'react';
import {
  getHourlyLabel,
  ProfessionalReplacementTypes,
  ServiceTypes,
} from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import {
  ChipType,
  ReplacementLabels,
  toWeekdayWeekendFormat,
} from '../../../helpers/Constants';
import HourlyRateChipLabel from './HourlyRateChipLabel';
import CustomChip from '../CustomChip';
import strings from '../../../localization';
import styles from './styles';

interface IAdminLongTermUserRates {
  contractStartDate?: string;
  pharmacyWeekDayHourlyRate?: number;
  pharmacyWeekendHourlyRate?: number;
  weekDayHourlyRate?: number;
  weekendHourlyRate?: number;
  successAction: string;
  isPromoBooking?: boolean;
  replacementType?: ProfessionalReplacementTypes;
  pharmacyInfoText?: string;
}

const AdminLongTermUserRates = ({
  pharmacyWeekDayHourlyRate,
  pharmacyWeekendHourlyRate,
  weekDayHourlyRate,
  weekendHourlyRate,
  pharmacyInfoText,
  contractStartDate,
  replacementType,
  isPromoBooking,
  successAction,
}: IAdminLongTermUserRates) => {
  const isSelfService = ServiceHandler.getService() === ServiceTypes.self;
  const showPharmacyLongTermLabel = !isSelfService && contractStartDate;
  const pharmacyLabel = toWeekdayWeekendFormat(
    pharmacyWeekDayHourlyRate,
    pharmacyWeekendHourlyRate,
  );
  const label = toWeekdayWeekendFormat(weekDayHourlyRate, weekendHourlyRate);
  const userLabel = strings.formatString(
    strings.hourlyRateFormat,
    ReplacementLabels()[
      replacementType ?? ProfessionalReplacementTypes.pharmacist
    ],
  ) as string;

  return {
    customPharmacyChip: showPharmacyLongTermLabel ? (
      <HourlyRateChipLabel
        customContainerStyle={[styles.chipContainer]}
        customLabelStyle={{ fontSize: 11 }}
        label={`${strings.pharmacyHourlyRate} ${getHourlyLabel(
          pharmacyWeekDayHourlyRate,
          pharmacyWeekendHourlyRate,
        )}`}
        infoText={pharmacyInfoText}
        customChip={(
          <CustomChip
            label={pharmacyLabel}
            type={isPromoBooking ? ChipType.promoBooking : ChipType.hourlyRate}
          />
        )}
        type={ChipType.hourlyRate}
        successAction={successAction}
      />
    ) : null,
    customPharmacistChip: contractStartDate ? (
      <HourlyRateChipLabel
        customLabelStyle={{ fontSize: 11 }}
        customContainerStyle={styles.chipContainer}
        label={`${userLabel} ${getHourlyLabel(
          weekDayHourlyRate,
          weekendHourlyRate,
        )}`}
        customChip={<CustomChip label={label} type={ChipType.hourlyRate} />}
        type={ChipType.hourlyRate}
        successAction={successAction}
      />
    ) : null,
  };
};

export default AdminLongTermUserRates;
